import { render, staticRenderFns } from "./FieldCustomerDeliveryZip.vue?vue&type=template&id=0f19993f&"
import script from "./FieldCustomerDeliveryZip.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerDeliveryZip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports